import Steps from './Steps';
import StepsItem from './StepsItem';

Steps.Item = StepsItem;
export default Steps;
